<template>
  <el-dialog
    title="关联合同"
    append-to-body
    :visible="dialogVisible"
    :close-on-click-modal="false"
    center
    width="80%"
    @close="closeDialog"
  >
    <sirui-table
      ref="siruiTable"
      @handleSelectionChange="handleSelectionChange"
      :data="relatedTableData"
      :paging="false"
      :setting="false"
      :customVisible="false"
      :columns="searchColumn"
      :cellClick="cellClick"
      :cellStyle="cellStyle"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
      <!-- <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column> -->
      <vxe-table-column
        v-for="(item, index) in searchColumn"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
        :visible="item.visible"
        :type="item.type"
        :width="item.width"
      >
      </vxe-table-column>
    </sirui-table>
    <span slot="footer" class="dialog-footer" v-if="relatedTableData.length > 0">
      <el-button @click="cancelRelated" type="primary">取消关联</el-button>
      <el-button @click="closeDialog" type="primary">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import API from '@/api/property/leaseContract';
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  import {
    auditStatusList,
    contractCategoryList,
    contractStatusList,
    relateTypeList,
  } from '../data';
  export default {
    name: 'relatedDetailDialog',
    mixins: [leaseContractMixin],
    props: ['dialogVisible', 'contractId'],
    computed: {
      searchColumn() {
        return [
          {
            field: 'relateTypeName',
            title: '关联方式',
            visible: true,
          },
          {
            field: 'contractNo',
            title: '合同编号',
            visible: true,
          },
          {
            field: 'contractName',
            title: '合同名称',
            visible: true,
          },
          {
            field: 'contractCategoryName',
            title: '合同类型',
            visible: true,
          },
          {
            field: 'customerName',
            title: '客户名称',
            visible: true,
          },
          {
            field: 'signPartyName',
            title: '签约方',
            visible: true,
          },
          // {
          //   field: 'leaseAsset',
          //   title: '租赁资产',
          //   visible: true,
          // },
          {
            field: 'leaseDuration',
            title: '租赁期限',
            visible: true,
          },
          {
            field: 'auditStatusName',
            title: '审核状态',
            visible: true,
          },
          {
            field: 'contractStatusName',
            title: '合同状态',
            visible: true,
          },
        ];
      },
    },
    created() {
      if (this.contractId) {
        this.getContractDetail();
      }
    },
    data() {
      return {
        relatedTableData: [],
        multipleSelection: [],
        auditStatusList,
        contractCategoryList,
        contractStatusList,
        relateTypeList,
      };
    },
    methods: {
      getContractDetail() {
        this.$axios.post(`${API.DETAIL_RELATED_CONTRACT}/${this.contractId}/relate`).then((res) => {
          if (res.data.code === 0) {
            this.relatedTableData = res.data.data || [];
            this.relatedTableData.forEach((item) => {
              item.auditStatusName = this.transferSelect(item.auditStatus, this.auditStatusList);
              item.contractCategoryName = this.transferSelect(
                item.contractCategory,
                this.contractCategoryList
              );
              item.contractStatusName = this.transferSelect(
                item.contractStatus,
                this.contractStatusList
              );
              item.relateTypeName = this.transferSelect(item.relateType, this.relateTypeList);
              item.leaseDuration =
                item.leaseDateFrom && item.leaseDateUntil
                  ? `${item.leaseDateFrom.replaceAll('-', '.')}-${item.leaseDateUntil.replaceAll(
                      '-',
                      '.'
                    )}`
                  : '';
            });
          }
        });
      },
      cancelRelated() {
        const length = this.multipleSelection.length;
        if (length === 0) {
          return this.$message({
            showClose: true,
            message: '请选择数据！',
            type: 'warning',
          });
        } else if (length > 1) {
          return this.$message({
            showClose: true,
            message: '请选择一条数据！',
            type: 'warning',
          });
        } else {
          // const selectedData = this.multipleSelection[0] || {};
          // console.log(selectedData, 'selectedData');
          let hasRelatedStatus = false;
          this.multipleSelection.map((item) => {
            if (item.relateType === '02') {
              hasRelatedStatus = true;
            }
          });
          if (hasRelatedStatus) {
            return this.$message({
              showClose: true,
              message: '自动关联的合同不能取消关联',
              type: 'warning',
            });
          }
          let ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          const params = {
            id: this.contractId,
            relateIds: ids,
          };
          this.$axios.post(API.CANCEL_RELATED_CONTRACT, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg || '操作成功',
                type: 'success',
              });
              this.closeDialog();
            }
          });
        }
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      cellClick(val) {
        if (val.column?.property === 'contractNo') {
          const path = {
            path: 'propert/detailLeaseContract',
            name: 'detailLeaseContract',
            meta: {
              keepAlive: true,
              title: '租赁合同详情',
            },
            query: {
              type: 'detail',
              contractId: val.row.id,
            },
          };
          this.$router.push(path);
        }
      },
      cellStyle({ column }) {
        if (column.property == 'contractNo') {
          // console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
          };
        }
      },
    },
  };
</script>
